import { useDataProvider } from 'react-admin';
import { useQuery } from 'react-query';

const useGetTeacherRates = (id) => {
  const dataProvider = useDataProvider();
  const query = useQuery(['getTeacherRates', id], () => {
    if (id) return dataProvider.getTeacherRates(id).then(({ data }) => data);
  });

  return query;
};

export default useGetTeacherRates;
